import * as React from "react";
import { Switch as BaseSwitch } from "react-router-dom";
export const Switch = (props) => React.createElement(BaseSwitch, { ...props });
//# sourceMappingURL=Switch.js.map